module.exports = __webpack_public_path__ + "static/app-store-download-b83fc03aaccf2055d13df65f7b2d5d54.png";